import { ModifyWorkspaceUsers } from "./ModifyWorkspaceUsers";
import { ModifyWorkspacePlan } from "./ModifyWorkspacePlan";

import * as util from "./util";

const Analytics = {
    ModifyWorkspacePlan,
    ModifyWorkspaceUsers,
    util
};

export default Analytics;
